// extracted by mini-css-extract-plugin
module.exports = {"Component":"Card_Component__3vN98"};